var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75,142.5c37.28,0,67.5-30.22,67.5-67.5S112.28,7.5,75,7.5,7.5,37.72,7.5,75s30.22,67.5,67.5,67.5ZM75,150c41.42,0,75-33.58,75-75S116.42,0,75,0,0,33.58,0,75s33.58,75,75,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.49,75l-34.49-22.99v45.99l34.49-22.99ZM101.46,70.63c3.12,2.08,3.12,6.66,0,8.74l-40.8,27.2c-3.49,2.33-8.16-.18-8.16-4.37v-54.39c0-4.19,4.67-6.69,8.16-4.37l40.8,27.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.6ee40abb77b4ab0c25a4989c9f8c53a1.svg";
export { ForwardRef as ReactComponent };